import { authorizeIfLoggedIn } from "../../../components/Auth/AuthorizedApiClientBase";
import { TradingClient } from "./generated/TradingClient";

export const TradingClientFactory = () => {
    const tradingClient = new TradingClient(process.env.TRADING_BACKEND_URL);
    authorizeIfLoggedIn(tradingClient);

    return tradingClient;
}